module.exports = __webpack_public_path__ + "img/verizon.e9f192dd.svg";